import { FC, Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import routes, { AppRoute } from "routes";
import RouteWrapper from 'routes/routeWrapper';
import Loading from 'pages/loading/index';

import './app.scss';

const App: FC = () => (
    <Suspense fallback={<Loading />}>
      <Switch>
        {routes.map((route: AppRoute, index: number) => {
          const { 
            path, 
            component: Component, 
            layout: Layout, 
            isPrivate = false, 
            tabNav = false, 
            ...rest
          }: AppRoute = route;
          
          return (
            <RouteWrapper
              key={`app-route-${index}-${path}`}
              path={path}
              component={Component}
              layout={Layout}
              isPrivate={isPrivate}
              tabNav={tabNav}
              {...rest}
            />
          );
        })}
        <Redirect to="/" />
      </Switch>
    </Suspense>
);

export default App;